// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  HostBinding,
  Input,
  OnInit, Output,
  ViewChild
} from '@angular/core';
import { ExpandableAreaComponent } from 'ids-enterprise-ng';
import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';

@Component({
  selector: 'lm-columnar-adhoc-report-measures',
  standalone: false,
  templateUrl: './lm-columnar-adhoc-report-measures.component.html',
  styleUrls: [ './lm-columnar-adhoc-report-measures.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ ]
})
export class LMColumnarAdhocReportMeasuresComponent implements OnInit{
  @HostBinding('attr.data-automation-id') automationId = 'lm-columnar-adhoc-report-measures';
  @ViewChild(ExpandableAreaComponent) expandableArea: ExpandableAreaComponent | undefined;

  @Input() spec: LMListSpec;
  @Input() chartName: string;
  @Input() get facadeMeasures(): Array<LMFacadeField> {
    return this._facadeMeasures;
  }
  set facadeMeasures(value: Array<LMFacadeField>) {
    this._facadeMeasures = value;
    this.initializeAvailableMeasures();
  }

  @Output() measuresUpdated = new EventEmitter<LMAdhocAggField[]>();

  public readonly MEASURES_LIST = 'current-measures';
  public measuresHeader = Soho.Locale.translate('Measures');
  public availableMeasuresHeader = Soho.Locale.translate('AvailableMeasures');

  public selectedExpandableOpen = true; // Expandable Section Toggle

  public chartSpec: LMChartSpec;
  private _facadeMeasures: Array<LMFacadeField> = [];
  public measures: LMAdhocAggField[] = [];
  public availableMeasures: Array<LMFacadeField> = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.chartSpec = this.spec.busListSpec.charts.find((c: LMChartSpec) => c.id === this.chartName);
    if (!this.chartSpec) {
      //Print error
      return;
    }
    this.measures = this.chartSpec.aggFields.filter((field: LMAggField) => field.isTotal) as LMAdhocAggField[] ;
  }

  private initializeAvailableMeasures() {
    if (!this.facadeMeasures || !this.measures)
      return;
    this.facadeMeasures.forEach(f => {
      // Measures can be added with different operators
      // if (!this.measures.some(d => d.fieldId === f.fieldId)) {
      this.availableMeasures.push(f);
      // }
    });
    this.availableMeasures.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    this.changeDetectorRef.markForCheck();
  }


  canDrop = (drag: CdkDrag, drop: CdkDropList): boolean => {
    return !!drag.dropContainer.data.includes(this.MEASURES_LIST);
  };

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer.data.includes(this.MEASURES_LIST)) {
      this.reorderDisplayField(event.currentIndex, event.previousIndex, event.item.data);
    }
  }

  public reorderDisplayField(newIndex: number, oldIndex: number, data: any) {
    // Reordering measures
    if (newIndex !== oldIndex && newIndex >= 0 && newIndex < this.measures.length) {
      const field = this.measures.splice(oldIndex, 1)[0];
      this.measures.splice(newIndex, 0, field);

      this.measuresUpdated.emit(this.measures);
      this.changeDetectorRef.markForCheck();
    }
  }

  public setMeasure(i: number) {
    // Measures property sheet
    // Evaluate the need for it
  }

  public addMeasure(i: number) {
    const measureToAdd = this.availableMeasures[i];
    this.measures.push({
      index: this.measures.length,
      added: true,
      columnId: measureToAdd.fieldId,
      filterFieldId: measureToAdd.fieldId,
      fieldId: measureToAdd.fieldId, // Already has the operator in facade definition
      isDefaultSort: false,
      label: { resourceValue: measureToAdd.name },
      isTotal: true,
      type: measureToAdd.uiFieldSpec.fieldType
    });

    this.measuresUpdated.emit(this.measures);
    this.changeDetectorRef.markForCheck();
  }
  public removeMeasure(i: number) {
    this.measures.splice(i, 1);

    this.measuresUpdated.emit(this.measures);
    this.changeDetectorRef.markForCheck();
  }

  toggleHeaders($event: Event): void {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if (this.expandableArea) {
      if (this.selectedExpandableOpen) {
        this.expandableArea.close();
        this.selectedExpandableOpen = false;
      } else {
        this.expandableArea.open();
        this.selectedExpandableOpen = true;
      }
    }
  }

}
